import React, {useState, useEffect} from "react";
import { useLocation } from "@reach/router"
import { Link } from "gatsby"
import { slide as Menu } from "react-burger-menu";
import LazyAndPreloadImage from "../functions/lazy_and_preload_image"

const AccordionItem = ({ linkto, title, children }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="accordion-item">
      <div className="accordion-button">
        <Link to={linkto}>{title}</Link>
        <span className={isOpen ? 'minus' : 'plus'} onClick={() => setIsOpen(!isOpen)}></span>
      </div>
      {isOpen && <div className="accordion-content">{children}</div>}
    </div>
  );
};

export default function SpSlideMenu() {

  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    // ページ遷移時にメニューを閉じる
    setMenuOpen(false);
  }, [location]);

  const handleStateChange = (state) => {
    setMenuOpen(state.isOpen);
  };

  return (
    <Menu right isOpen={menuOpen} onStateChange={handleStateChange}>
      {/*//////////////////////////////* ↓スマホスライドメニュー * //////////////////////////////*/}
      <div className="nav_sp sp_only">
        <div className="nav_sp_in">
          <Link className="logo" to="/">
            <LazyAndPreloadImage imgUrl={"/images/pc/common/jfeel_logo.svg"}  alt="J.Feel コーポレートサイト" width="97" height="33" />
          </Link>
          <Link className="sp_mail_link" to="https://ma.j-feel.jp/inquiry.html">お問い合わせ</Link>
          <div className="accordion">
            <AccordionItem title="ジェイフィールの想い" linkto="/philosophy">
            <Link to="/philosophy#mission_ttl">ミッション</Link>
              <Link to="/philosophy#key_method_ttl">キーメソッド</Link>
              <Link to="/philosophy#symbol_ttl">ジェイフィールのロゴ</Link>
            </AccordionItem>
            <AccordionItem title="セミナーを探す" linkto="/seminar">
              <Link to="/seminar">セミナー一覧</Link>
              <Link to="/seminar/archive">過去開催したセミナー</Link>
            </AccordionItem>
            {/* <AccordionItem title="プログラムを探す" linkto="/program"></AccordionItem> */}
            <Link to="/program" className="nav-item">
              プログラムを探す<span className="arrow"></span>
            </Link>
            <AccordionItem title="導入事例・コラムを読む" linkto="/note">
              <Link to="/note">すべての記事</Link>
              <Link to="/note/case-study">導入事例</Link>
              <Link to="/note/column">コラム・リサーチ</Link>
              <Link to="/note/culture">ジェイフィールの文化</Link>
            </AccordionItem>
            <AccordionItem title="会社紹介" linkto="/company">
              <Link to="/company#greeting_ttl">ご挨拶</Link>
              <Link to="/company#overview_ttl">会社概要</Link>
              <Link to="/company#supporter_ttl">サポーターのご紹介</Link>
              <Link to="/recruit">採用情報</Link>
            </AccordionItem>
          </div>
          <div className="submenu">
            <Link to="/publication">メディア掲載・書籍出版</Link>
            <Link to="/community">コミュニティ紹介</Link>
            <Link to="/newsletter">ニューズレター</Link>
          </div>
        </div>{/* nav_sp_in */}
      </div>{/* /nav_sp */}
      {/*//////////////////////////////* ↑スマホスライドメニュー * //////////////////////////////*/}
    </Menu>
  )
}
